/**
 * @Author: zachalam
 * @Date:   2017-01-25T11:42:03-08:00
 * @Last modified by:   hiral
 * @Last modified time: 2024-08-15
 */

import React, { ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import LoadingBackdrop from '../atoms/loader/LoadingBackdrop';
import { logoutUserAction } from '../actions/authActions';

const LoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  position: 'relative',
});

const LogoutContainer = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logoutUserAction(navigate));
  }, []);

  return (
    <LoadingContainer>
      <LoadingBackdrop active={true} showLoadingBg={false} />
    </LoadingContainer>
  );
};

export default LogoutContainer;
